import React from 'react';

import {MODEL_RUN_SOURCE} from 'constants/AnalyticsConstants';
import Modal from 'ui-library/modals/Modal';

import {MODEL_CATEGORY, type ScientificModelNode} from '../ScientificModelMetadata';
import {BoltzGenInputForm} from './boltzgen/BoltzGenInputForm';
import StructurePredictionForm from './structure-prediction/StructurePredictionForm';

export interface ScientificModelInputFormProps {
  model: ScientificModelNode;
  onRequestClose: () => void;
}

export function ScientificModelInputForm({
  model,
  onRequestClose,
}: ScientificModelInputFormProps): JSX.Element {
  if (model.category === MODEL_CATEGORY.GENERATIVE) {
    return (
      <BoltzGenInputForm
        model={model}
        onRequestClose={onRequestClose}
        source={MODEL_RUN_SOURCE.MODEL_HUB_UI}
      />
    );
  } else if (model.category === MODEL_CATEGORY.STRUCTURE_PREDICTION) {
    return (
      <StructurePredictionForm
        availableModels={[model]}
        onSubmit={onRequestClose}
        startingModel={model}
        source={MODEL_RUN_SOURCE.MODEL_HUB_UI}
      />
    );
  } else {
    throw new Error(`Unsupported model type: ${model}`);
  }
}

export interface ScientificModelInputFormModalProps {
  model: ScientificModelNode;
  onRequestClose: () => void;
}

export function ScientificModelInputFormModal({
  model,
  onRequestClose,
}: ScientificModelInputFormModalProps): JSX.Element {
  return (
    <Modal
      title={`Configure ${model.displayName}`}
      onRequestClose={onRequestClose}
      closeableOnBackgroundClick={true}
      large={true}
      fullHeight={true}
      bodyPadded={false}
    >
      <ScientificModelInputForm model={model} onRequestClose={onRequestClose} />
    </Modal>
  );
}
